import React from "react";
import ProjectInformation from "../../components/Form/ProjectInformation/ProjectInformation.js";

const ProjectInformation_View = () => {
  return (
    <div>
      <ProjectInformation />
    </div>
  );
};

export default ProjectInformation_View;
